import { toast } from "sonner"
import { downloadDocuments, downloadProposals } from "../api/download_documents"

export const handleDownloadDocuments = async (project_id: string) => {
    try {
        toast.success("Downloading documents...")
        await downloadDocuments(project_id)
        toast.success("Documents downloaded successfully")
    } catch (error) {
        if (error instanceof Error) {
            if (error.message.includes("404")) {
                toast.error("Error downloading documents. The project may not have any documents.")
            } else if (error.message.includes("403")) {
                toast.error("Error downloading documents. You do not have permission to download documents.")
            } else {
                toast.error("Error downloading documents: " + error.message)
            }
        } else {
            toast.error("Error downloading documents: An unknown error occurred")
        }
    }
}

export const handleDownloadProposals = async (project_id: string) => { 
    try {
        toast.success("Downloading proposals...")
        await downloadProposals(project_id)
        toast.success("Proposals downloaded successfully")
    } catch (error) {
        if (error instanceof Error) {
            if (error.message.includes("404")) {
                toast.error("Error downloading proposals. The project may not have any proposals.")
            } else if (error.message.includes("403")) {
                toast.error("Error downloading proposals. You do not have permission to download proposals.")
            } else {
                toast.error("Error downloading proposals: " + error.message)
            }
        } else {
            toast.error("Error downloading proposals: An unknown error occurred")
        }
    }
}